import { CognitoUser, CognitoUserSession } from "amazon-cognito-identity-js";

export enum AuthChallenge {
    NEW_PASSWORD_REQUIRED = "NEW_PASSWORD_REQUIRED",
}

export interface ChallengeData {
    challenge: AuthChallenge;
    user: CognitoUser;
    session?: CognitoUserSession;
    requiredAttributes?: string[];
}

export interface LoginResult {
    success: boolean;
    session?: CognitoUserSession;
    challengeData?: ChallengeData;
}
